import React, { useEffect, useMemo } from "react";
import { useField } from "formik";
import { useTranslation } from "react-i18next";
import { Select } from "components/common";
import RepositoryOption from "./RepositoryOption";
import useRepositories from "./hooks/useRepositories";
const RepositorySelect = ({ fieldName, disabled = false, type = void 0 }) => {
  const { t } = useTranslation("enterprise_data_tiering");
  const [{ name, onChange, onBlur }, { value, touched }, { setValue, setTouched }] = useField(fieldName);
  const { repositories } = useRepositories(type);
  const repos = useMemo(() => {
    var _a;
    return (_a = repositories.data) != null ? _a : [];
  }, [repositories.data]);
  const buildOptions = () => repos.map((repo) => ({
    value: repo.repository.name,
    label: repo.repository.name,
    ready: repo.ready,
    status: repo.status,
    type: repo.repository.type,
    provider: repo.provider,
    description: repo.details
  }));
  const optionRenderer = (option, isSelected) => /* @__PURE__ */ React.createElement(RepositoryOption, { repository: option, isSelected });
  useEffect(() => {
    if (!touched && value === null && repos.length > 0) {
      setValue(repos[0].repository.name);
    }
  }, [touched, setValue, value, repos]);
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      disabled,
      placeholder: t("repository_select.placeholder"),
      options: buildOptions(),
      optionRenderer,
      autoFocus: true,
      required: true,
      onBlur,
      onChange: (selected) => {
        onChange({ target: { value: selected, name } });
        setTouched(true, false);
      },
      value
    }
  );
};
export default RepositorySelect;
